import { hot } from 'react-hot-loader';
import React, { PureComponent } from 'react';
import CustomLoader from 'components/CustomLoader';
import Loadable from 'react-loadable';

const LoadableComponent = Loadable({
  loader: () =>
    import('containers/App/index.js' /* webpackChunkName: "app__chunk" */ /* webpackPrefetch: true */),
  loading: (props) => <CustomLoader {...props} background />,
  delay: 300,
  timeout: 10000,
});

class App extends PureComponent {
  render() {
    return <LoadableComponent {...this.props} />;
  }
}

export default hot(module)(App);
